import React from "react";
import Constructor from "./Constructor";
import {Route, Routes} from "react-router-dom";
import ConstructorPeriodsValues from "./decadeConstructor/Constructor.PeriodsValues";
import ConstructorTemporaryTurn from "./temporaryTurnConstructor/Constructor.TemporaryTurn";
import ConstructorDefaultPage from "./Constructor.DefaultPage";
import ConstructorRainFlood from "./rainFlood/Constructor.RainFlood";
import ConstructorRiverFlood from "./riverFlood/Constructor.RiverFlood";
import {getPagesVisibility} from "../Privileges/PrivilegesSelectors";
import {useSelector} from "react-redux";
import ConstructorEvaporation from "./evaporation/ConstructorEvaporation";

export default function ConstructorRouter() {
    const privileges = useSelector(state => state.login.privileges)

    const pagesVisibility = getPagesVisibility(privileges);

    return (
        <Constructor>
            <Routes>
                <Route path="/" element={<ConstructorDefaultPage/>}/>
                {pagesVisibility.CONSTRUCTORS && <Route path="day-decade-month-values" element={<ConstructorPeriodsValues/>}/> }
                {pagesVisibility.CONSTRUCTORS && <Route path="temporary-turn" element={<ConstructorTemporaryTurn/>}/> }
                {pagesVisibility.CONSTRUCTORS && <Route path="rain-flood" element={<ConstructorRainFlood/>}/> }
                {pagesVisibility.CONSTRUCTORS && <Route path="river-flood" element={<ConstructorRiverFlood/>}/> }
                {pagesVisibility.CONSTRUCTORS && <Route path="evaporation" element={<ConstructorEvaporation/>}/> }
            </Routes>
        </Constructor>
    );
}